import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowTeamsRoute extends BaseRoute {}
